import React from "react";
import "./Common.css";

function OneStopPortal() {
  const cards = [
    {
      title: "Real-time Analytics",
      desc: "Live KPI dashboards across all governance levels",
      image: "/Images/Realtime.svg",
      bg: "bg-success-subtle",
    },
    {
      title: "Geographic Insights",
      desc: "Interactive State, district & block maps",
      image: "/Images/Geographic.svg",
      bg: "bg-purple",
    },
    {
      title: "Visual Reports",
      desc: "Charts, graphs and index views for progress review",
      image: "/Images/Bar.svg",
      bg: "bg-success-subtle",
    },
  ];

  return (
    <section className="py-5">
      <div className="container">
        <div className="text-center mb-5">
          <span className="badge rounded-pill text-success bg-success-subtle px-3 py-2">
            DASHBOARD CAPABILITIES
          </span>

          <h1 className="fw-bold mt-3">
            One-Stop Portal for <br />
            <span className="text-success">
              Reporting, Monitoring and Review
            </span>
          </h1>

          <p className="text-secondary w-75 mx-auto">
            Anemia Mukt Bharat Abhiyaan is the updated flagship programme of the
            Ministry of Health & Family Welfare, Government of India. The
            dashboard presents KPIs interactively for State, district, and block
            levels using maps, bar graphs, charts, and indices for programme
            review and progress assessment.
          </p>
        </div>

        <div className="row g-4">
          {cards.map((item, index) => (
            <div className="col-md-4" key={index}>
              <div className="d-flex gap-3 align-items-start">
                <div className={`icon-box ${item.bg}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="icon-image"
                  />
                </div>

                <div>
                  <h6 className="fw-bold">{item.title}</h6>

                  <p className="text-secondary mb-0">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OneStopPortal;
